var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import packageInfo from '../package.json';
export var DATASET_VERSION = '3.4';
export function toDataSet(frameCache, signer, meta) {
    if (signer === void 0) { signer = undefined; }
    if (meta === void 0) { meta = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var timings, alignmentConfig, modelStates, analyticTuples, startTime, endTime, dataset, signature, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    timings = Array.from(frameCache.timingsSet);
                    timings.sort();
                    alignmentConfig = frameCache.parent.body.getAlignmentConfig();
                    modelStates = Object.fromEntries(frameCache.modelStates);
                    analyticTuples = Object.fromEntries(frameCache.analyticTuples);
                    startTime = timings[0];
                    endTime = timings[timings.length - 1];
                    dataset = __assign({ movementName: frameCache.parent.movementName || 'FREE PLAY', startTime: startTime, endTime: endTime, duration: Math.round((Number(endTime) - Number(startTime)) / 1000), version: DATASET_VERSION, sharedJSVersion: packageInfo.version, mobileAppId: frameCache.parent.mobileAppId, source: frameCache.parent.obcTopId + ":" + frameCache.parent.harnessTopId + "-" + frameCache.parent.obcBottomId + ":" + frameCache.parent.harnessBottomId, types: ['Gyro'], alignment: alignmentConfig, modelStates: modelStates, analyticTuples: analyticTuples, frameCount: frameCache.frameCount, timings: timings, timelineTags: frameCache.timelineTags }, meta);
                    if (!(typeof signer === 'function')) return [3, 5];
                    signature = 'EMPTY_SIG';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, signer(JSON.stringify(dataset))];
                case 2:
                    signature = _a.sent();
                    return [3, 4];
                case 3:
                    err_1 = _a.sent();
                    console.log('todataset-signer-error', err_1);
                    return [3, 4];
                case 4: return [2, JSON.stringify({
                        signature: signature,
                        dataset: dataset,
                    })];
                case 5: return [2, JSON.stringify(dataset)];
            }
        });
    });
}
//# sourceMappingURL=todataset.js.map